'use strict';

/**
 * Split a comma-separated string
 * */
customerZone.filter('split', [function(){
    return function(input, delimiter){
        if (!delimiter) delimiter = ',';
        return input ? input.split(delimiter) : [];
    };
}]);
